import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EConditionFields = {
	thresholdSource: 'thresholdSource',
	thresholds: 'thresholds',
	applyFor: 'applyFor',
	checkEveryHours: 'checkEveryHours',
	checkEveryMinutes: 'checkEveryMinutes',
	evaluationWindowHours: 'evaluationWindowHours',
	evaluationWindowMinutes: 'evaluationWindowMinutes',
} as const;

export const EThresholdSource = {
	setManually: 'MANUAL',
	useDefaultForKPIs: 'KPI_DEFAULT',
} as const;

export const EApplyFor = {
	allBuiltCharts: 'ALL_BUILT_CHARTS',
	atLeastOneBuiltChart: 'ONE_BUILT_CHART',
} as const;

export type TConditionFields = TValueOfStringRecord<typeof EConditionFields>
export type TThresholdSource = TValueOfStringRecord<typeof EThresholdSource>
export type TApplyFor = TValueOfStringRecord<typeof EApplyFor>
